import { Modal } from "react-bootstrap";
import { AddAttachmentModalProps } from "./Task.types";
import { GenericForm } from "../../components/generic-form";
import { Button } from "../../components/button";
import { useTranslation } from "react-i18next";

export const PinCommentModal = ({
  show,
  onDismiss,
  onSubmit,
  addAttachmentForm,
  adding,
}: AddAttachmentModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} animation onHide={onDismiss}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          {t("TASKS.ADD_ATTACHMENT")}
        </h5>
        <div onClick={onDismiss}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body className="flex-column gap-2">
        <GenericForm
          form={addAttachmentForm}
          onSubmit={(data) => onSubmit({ payload: data })}
          submitControl={(submit) => (
            <div className="flex-row">
              <Button
                isLoading={adding}
                loader={{ size: "s" }}
                className="btn btn-primary mt-3 w-100"
                type="submit"
              >
                {t("CREATE_BUTTON")}
              </Button>
            </div>
          )}
        />
      </Modal.Body>
    </Modal>
  );
};
